import React, { FC, useState } from 'react';
import UpdateAvatarForm from './UpdateAvatarForm';
import { DialogTitle } from './CustomDialogTitle';
import { Dialog, DialogContent, MenuItem, ListItemIcon } from '@mui/material';
import FaceIcon from '@mui/icons-material/Face';

interface UpdateAvatarModalProps {
  handleCloseMenu: () => void;
  user: {
    avatar?: {
      exists?: boolean;
    };
  };
}

const UpdateAvatarModal: FC<UpdateAvatarModalProps> = ({ handleCloseMenu, user }) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
    handleCloseMenu();
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <MenuItem onClick={handleClickOpen}>
        <ListItemIcon>
          <FaceIcon style={{ marginRight: 'var(--space-icon-gap)' }} />
          {user.avatar?.exists ? 'Change Avatar' : 'Add Avatar'}
        </ListItemIcon>
      </MenuItem>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        PaperProps={{ sx: { p: 0, overflow: 'hidden' } }}
        fullWidth
      >
        <DialogTitle onClose={handleClose}>
          {user.avatar?.exists ? 'Update your avatar' : 'Add an avatar'}
        </DialogTitle>
        <DialogContent>
          <UpdateAvatarForm closeModal={handleClose} />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default UpdateAvatarModal;
